import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      data-footer
      sx={{
        py: 4,
        bgcolor: '#f8f9fa',
        borderTop: '1px solid #e9ecef',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img 
                src="/assets/akmobooks.com.svg" 
                alt="AkMo Books Logo" 
                style={{ height: '23px', width: 'auto' }} 
              />
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  backgroundImage: 'var(--primary-gradient)',
                  backgroundClip: 'text',
                  color: 'transparent',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                AkMo Books
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()}{' '}
              <Typography
                component="a"
                href="https://akmotechnologies.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                AkMo Solutions Private Limited
              </Typography>
              . All rights reserved.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: { xs: 'flex-start', md: 'flex-end' } }}
            >
              <Button 
                color="inherit" 
                size="small"
                onClick={() => navigate('/privacy-policy')}
                sx={{ 
                  '&:hover': { 
                    color: 'primary.main',
                    textDecoration: 'underline'
                  } 
                }}
              >
                Privacy Policy
              </Button>
              <Button 
                color="inherit" 
                size="small"
                onClick={() => navigate('/terms-of-service')}
                sx={{ 
                  '&:hover': { 
                    color: 'primary.main',
                    textDecoration: 'underline'
                  } 
                }}
              >
                Terms of Service
              </Button>
              <Button 
                color="inherit" 
                size="small"
                onClick={() => navigate('/contact')}
                sx={{ 
                  '&:hover': { 
                    color: 'primary.main',
                    textDecoration: 'underline'
                  } 
                }}
              >
                Contact Us
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
